import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sidebar js-sidebar" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-star-white" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-star-white" }, null, -1)
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "tender-sidebar-info" }
const _hoisted_6 = { class: "tender-sidebar-info__title" }
const _hoisted_7 = { class: "tender-sidebar-info__value is-company-name" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "tender-sidebar-info__title" }
const _hoisted_10 = { class: "tender-sidebar-info__value" }
const _hoisted_11 = { class: "tender-sidebar-info__title" }
const _hoisted_12 = { class: "tender-sidebar-info__value" }
const _hoisted_13 = { class: "tender-sidebar-info__title" }
const _hoisted_14 = { class: "tender-sidebar-info__value" }
const _hoisted_15 = { class: "tender-sidebar-info__title" }
const _hoisted_16 = { class: "tender-sidebar-info__value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    (_ctx.isAuthenticated && !_ctx.isFavourite)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleSavePurchase && _ctx.handleSavePurchase(...args))),
          class: "btn btn-blue btn--w-icon save-search-btn js-save-favorite"
        }, [
          _hoisted_2,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("tender_page.add_favourite_btn")), 1)
        ]))
      : (_ctx.isAuthenticated && _ctx.isFavourite)
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleDeletePurchase && _ctx.handleDeletePurchase(...args))),
            class: "btn btn-white btn--w-icon save-search-btn js-save-favorite"
          }, _toDisplayString(_ctx.$t("tender_page.is_favourite")), 1))
        : (_openBlock(), _createElementBlock("a", {
            key: 2,
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleAuthModal && _ctx.toggleAuthModal(...args))),
            class: "btn btn-blue btn--w-icon save-search-btn js-save-favorite"
          }, [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("tender_page.add_favourite_btn")), 1)
          ])),
    _createElementVNode("a", {
      href: _ctx.getTender.url,
      target: "_blank",
      class: "btn btn-white",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleOpenSource && _ctx.handleOpenSource(...args)))
    }, _toDisplayString(_ctx.$t("tender_page.open_source_btn")), 9, _hoisted_4),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.getTender.company_inn || "–"), 1),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.getTender.company_inn)
          ? (_openBlock(), _createBlock(_component_RouterLink, {
              key: 0,
              to: { path: `/company/${_ctx.getTender.company_inn}`, query: { page: '1' }},
              target: "_blank",
              class: "company-url"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.getTender.company), 1)
              ]),
              _: 1
            }, 8, ["to"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.getTender.company), 1))
      ]),
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("tender_details.contact_person")), 1),
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.getTender.contact_person || "–"), 1),
      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("tender_details.phone")), 1),
      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.getTender.phone || "–"), 1),
      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("tender_details.email")), 1),
      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.getTender.email || "–"), 1),
      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("tender_details.company_inn")), 1),
      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.getTender.company_inn || "–"), 1)
    ])
  ]))
}